import { z } from "zod";
import { RevenueCalculationSchema, ValidateRevenueCalculation } from "./RevenueCalculation";

export const EditPermanentServiceSchema = z
  .object({
    // Add any other fields specific to EditPermanentServiceSchema here
    // For future possible fields that needs to be part of EditPermanentServiceSchema
  })
  .extend(RevenueCalculationSchema.shape)
  .check((ctx) => {
    ValidateRevenueCalculation(ctx);
  });

export type TEditPermanentServiceSchema = z.infer<typeof EditPermanentServiceSchema>;
